export default "/documents/images/vendor/pdfjs-dist/web/loading-icon.gif?ff2dfa442d903d9d5e303345b82e5415";